/**
 * Виды ошибок с собственным `type` (ADR-032). Фронты сравнивают `type` с этими константами,
 * а не с текстом. Обычные HTTP-ошибки (404, ошибка валидации) — `about:blank`.
 */
export const PROBLEM_TYPES = {
    unauthenticated: 'urn:problem-type:unauthenticated',
    forbidden: 'urn:problem-type:forbidden',
    mfaRequired: 'urn:problem-type:mfa-required',
    stepUpRequired: 'urn:problem-type:step-up-required',
    invalidCredentials: 'urn:problem-type:invalid-credentials',
    /** Неверный код 2FA или код восстановления при действующей сессии (400, сессия жива). */
    invalidCode: 'urn:problem-type:invalid-code',
    /** Неверный текущий пароль при действующей сессии (400). */
    invalidPassword: 'urn:problem-type:invalid-password',
    /** Второй фактор недоступен (секрет повреждён или ключ удалён) — нужен сброс 2FA. */
    mfaUnavailable: 'urn:problem-type:mfa-unavailable',
    accountLocked: 'urn:problem-type:account-locked',
    rateLimited: 'urn:problem-type:rate-limited',
    csrfRejected: 'urn:problem-type:csrf-rejected',
    misconfiguredRoute: 'urn:problem-type:misconfigured-route',
    serviceBusy: 'urn:problem-type:service-busy',
    /** Файл больше предела назначения или настройки `files.maxUploadMb` (422, поле `maxSize`). */
    fileTooLarge: 'urn:problem-type:file-too-large',
    /** Состояние файла не допускает действие: загрузка уже завершена или файл не готов (409). */
    fileState: 'urn:problem-type:file-state',
};
//# sourceMappingURL=problem-types.js.map